/**
 * Serialization utilities for localStorage operations
 * Handles conversion between JavaScript types and JSON-safe formats
 */

/**
 * Date serialization utilities
 * Handles conversion between Date objects and ISO 8601 strings
 */
export const DateSerializer = {
  /**
   * Serializes a Date object to an ISO 8601 string
   * @param date - The Date object to serialize, or null
   * @returns ISO 8601 string representation, or null if input is null
   */
  serialize(date: Date | null): string | null {
    return date ? date.toISOString() : null;
  },

  /**
   * Deserializes an ISO 8601 string to a Date object
   * @param dateString - The ISO 8601 string to deserialize, or null
   * @returns Date object, or null if input is null or invalid
   */
  deserialize(dateString: string | null): Date | null {
    if (!dateString) return null;
    try {
      return new Date(dateString);
    } catch {
      console.warn(`Failed to parse date: ${dateString}`);
      return null;
    }
  },
};
